<template>
  <div>
    <b-row class="mt-4">
      <b-col lg="12">
        <h4>CBS</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="2">
        <InputMoney label="Dev. Tributos" disabled :precision="2" :value="vDevTrib" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Diferimento" disabled :precision="2" :value="vDif" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="CBS" disabled :precision="2" :value="vCBS" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Créd. Pres" disabled :precision="2" :value="vCredPres" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Créd. Pres. Sus" disabled :precision="2" :value="vCredPresCondSus" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="CBS Mono." disabled :precision="2" :value="vCBSMono" />
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="2">
        <InputMoney label="CBS Mono. Ret." disabled :precision="2" :value="vCBSMonoRet" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="CBS Mono. Reten" disabled :precision="2" :value="vCBSMonoReten" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { InputMoney } from '@/components/Form';

export default {
  name: 'CBSTaxes',
  components: {
    InputMoney,
  },
  props: {
    IbsTaxRegimeTotals: {
      type: Object,
      required: true,
    },
  },
  computed: {
    vDevTrib() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gCBS?.vDevTrib || 0;
    },
    vDif() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gCBS?.vDif || 0;
    },
    vCBS() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gCBS?.vCBS || 0;
    },
    vCredPres() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gCBS?.vCredPres || 0;
    },
    vCredPresCondSus() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gCBS?.vCredPresCondSus || 0;
    },
    vCBSMono() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gMono?.vCBSMono || 0;
    },
    vCBSMonoRet() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gMono?.vCBSMonoRet || 0;
    },
    vCBSMonoReten() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gMono?.vCBSMonoReten || 0;
    },
  },
};
</script>
